import React, { useState } from "react";
import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { Branded } from "./Branded";
import PaginationUI from "../atoms/PaginationUI";

type InfoCoutaProps = {
  description: string;
  date: string;
};

type RoutineProps = {
  id: number | string;
  name: string;
  description: string;
  period: string;
  status: string;
  infoPage: InfoCoutaProps;
};

type option = {
  id: string | number;
  title: string;
  description: string;
  function: ({ id, routine }: any) => void;
};

export type TTableListTrainProps = {
  training: RoutineProps[];
  OptionsBrandedActiveFee: option[];
  titleBrandedActiveFee?: string;
};

const TableListTrain: React.FC<TTableListTrainProps> = ({
  training,
  OptionsBrandedActiveFee,
  titleBrandedActiveFee,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const paginatedData = training?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="mt-5">
      <div className="px-2 sm:px-3 lg:px-6">
        <div className="flow-root">
          <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full px-7 py-2 align-middle">
              {paginatedData?.length === 0 ? (
                <Empty texto="no hay datos" />
              ) : (
                <Fragment>
                  <table className="min-w-full divide-y divide-gray-300 border-t border-gray-300">
                    <thead>
                      <tr>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Nombre
                        </th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Descripción
                        </th>
                        <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          Periodo
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {paginatedData?.map((routine) => (
                        <tr key={routine.id}>
                          <ColumnText title={routine.name} />
                          <ColumnText title={routine.description} />
                          <ColumnText title={routine.period} />
                          <ColumnText title={routine.status} />
                          <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                            <Branded
                              title={titleBrandedActiveFee}
                              publishingOptions={OptionsBrandedActiveFee.map(
                                (option) => ({
                                  ...option,
                                  function: () =>
                                    option.function({
                                      id: routine.id,
                                      routine: routine,
                                    }),
                                })
                              )}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>

      <PaginationUI
        currentPage={currentPage}
        totalPages={Math.ceil(training?.length / pageSize)}
        onPageChange={setCurrentPage}
        pageSize={pageSize}
        totalResults={training?.length}
      />
    </div>
  );
};

export default TableListTrain;
